import { Entity } from '@core/entities/entity/Entity'
import { ICreateMFASession } from './ICreateMFASession'
import { plainToInstance } from 'class-transformer'

export class CreateMFASession extends Entity<ICreateMFASession> {
  token: string
  email: string
  codeValidity: number
  allowSkip: boolean
  enforceOn: string
  tokenValidityInSeconds: number
  skipDurationSeconds: number

  public static new(payload: unknown): CreateMFASession {
    return plainToInstance(CreateMFASession, payload)
  }

  public static formatDuration(seconds: number): string {
    const days = Math.floor(seconds / (24 * 60 * 60))
    const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60))
    const minutes = Math.floor((seconds % (60 * 60)) / 60)
    const secondsRemaining = seconds % 60

    const parts = []
    if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`)
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`)
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`)
    if (secondsRemaining > 0)
      parts.push(
        `${secondsRemaining} second${secondsRemaining !== 1 ? 's' : ''}`,
      )

    return parts.join(' ')
  }

  public static getTokenValidityTime(tokenValidityInSeconds: number): string {
    return this.formatDuration(tokenValidityInSeconds)
  }

  public static getSkipDurationTime(skipDurationSeconds: number): string {
    return this.formatDuration(skipDurationSeconds)
  }

  public static getEnforceOnDate(enforceOn: string): string {
    return new Date(enforceOn).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
  }
}
